export const statusColors = {
  present: '#86BF00',
  late: '#AAAAAA',
  overtime: '#0D94CF',
  onBreak: '#AAAAAA',
};
